import { render, staticRenderFns } from "./pushOrderTip.vue?vue&type=template&id=690fde53&scoped=true"
import script from "./pushOrderTip.vue?vue&type=script&lang=js"
export * from "./pushOrderTip.vue?vue&type=script&lang=js"
import style0 from "./pushOrderTip.vue?vue&type=style&index=0&id=690fde53&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690fde53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('690fde53')) {
      api.createRecord('690fde53', component.options)
    } else {
      api.reload('690fde53', component.options)
    }
    module.hot.accept("./pushOrderTip.vue?vue&type=template&id=690fde53&scoped=true", function () {
      api.rerender('690fde53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/logisticsOrders/components/pushOrderTip.vue"
export default component.exports